<div class="method-pipeline-manager">
  <div class="method-pipeline-manager__header">
    <h3 class="method-pipeline-manager__title">{{ 'core.pipelines' | translate | uppercase }}</h3>
  </div>

  <button type="button" class="btn btn-primary btn-block" (click)="onNewPipeline()" data-cy="new-pipeline">
    <i class="ri-add-circle-line"></i>
    {{ 'button.new_pipeline' | translate }}
  </button>

  <div class="method-pipeline-manager__lists">
    <!-- Left: all available pipelines (paginated catalog with search) -->
    <section class="method-pipeline-manager__list">
      <h4 class="method-pipeline-manager__list-title">{{ 'title.existing_pipelines' | translate }}</h4>

      <ts-paginated-search-header
        [searchValue]="facade.searchTerm$ | async"
        [previousTokens]="facade.previousPipelineTokens$ | async"
        [lastItem]="facade.nextPipelineToken$ | async"
        [length]="facade.totalCount$ | async"
        [pageSize]="facade.pageSize$ | async"
        [pageSizeOptions]="pageSizeOptions"
        [disabled]="facade.loading$ | async"
        [counting]="facade.counting$ | async"
        (searchChanged)="searchTermChanged($event)"
        (pageChange)="handlePageEvent($event)"
      ></ts-paginated-search-header>

      <ts-pipelines-list
        [items]="facade.availablePipelines$ | async"
        [columns]="leftColumns"
        [currentLanguage]="facade.currentLanguage$ | async"
        [loading]="facade.loading$ | async"
        [noPipelines]="facade.noPipelines$ | async"
        (assignedToggled)="onToggleAvailable($event)"
      ></ts-pipelines-list>
    </section>

    <!-- Right: pipelines assigned to this method type (paginated, no search) -->
    <section class="method-pipeline-manager__list method-pipeline-manager__list--assigned">
      <h4 class="method-pipeline-manager__list-title">{{ 'title.pipelines_assigned' | translate }}</h4>

      <div class="method-pipeline-manager__assigned-paginator">
        <ts-token-paginator
          [previousTokens]="facade.assignedPreviousTokens$ | async"
          [lastItem]="facade.assignedNextToken$ | async"
          [length]="facade.assignedTotalCount$ | async"
          [pageSize]="facade.assignedPageSize$ | async"
          [pageSizeOptions]="pageSizeOptions"
          [hidePageSize]="true"
          [disabled]="facade.assignedLoading$ | async"
          [counting]="facade.assignedCounting$ | async"
          (pageChange)="handleAssignedPageEvent($event)"
        ></ts-token-paginator>
      </div>

      <ts-pipelines-list
        [items]="facade.assignedPipelines$ | async"
        [columns]="rightColumns"
        [currentLanguage]="facade.currentLanguage$ | async"
        [loading]="facade.assignedLoading$ | async"
        [noPipelines]="facade.assignedNoPipelines$ | async"
        emptyMessageKey="info.no_assigned_pipelines"
        (assignedToggled)="onUnassign($event)"
        (editClicked)="onEditPipeline($event)"
      ></ts-pipelines-list>
    </section>
  </div>
</div>
